<template>
  <li
    :key="item.id || (item.caption + (item.type ? item.type.type : 'type') )"
    class="additional-field-row flex flex-between width-100"
    :data-qa="`additional-field-row${item.id || (item.caption + (item.type ? item.type.type : 'type') )}`">
    <div class="additional-field-row__title-wrapper flex text-left">
      <sIcon
        v-if="icon"
        class="additional-field-row__icon my-auto mx-2"
        :type="icon"/>
      <div class="additional-field-row__title h7-text my-auto">
        {{ item.caption }}
      </div>
    </div>
    <AdditionalBlockActions
      :can-delete="canDelete"
      :can-edit="canEdit"
      class="additional-field-row__btn"
      :item="item"
      :sort-down="index !== 0"
      :sort-up="index !== count - 1"
      @changeOrder="(event) => $emit('changeOrder', event)"
      @deleteField="$emit('deleteField', item)"
      @editField="$emit('editField', item)"/>
  </li>
</template>
<script>
import AdditionalBlockActions from 'components/additional fields/AdditionalBlockActions.vue'

import { additionalFieldsMixin } from 'mixins'

export default {
  name: 'additionalFieldRow',
  mixins: [additionalFieldsMixin],
  data() {
    return {
      icon: ''
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    count: {
      type: Number,
    },
    index: {
      type: Number,
    },
    /**
     * Сущность для привязки
     */
    entity: {
      type: Object
    }
  },
  computed: {
    canDelete() {
      if (!this.entity) { return true }
      const useTypeId = this.biddingTypeIds.includes(this.entity.biddingTypeId)
      const useClassificationCodes = this.classificationCodes.includes(this.entity.classificationCode)
      return !useTypeId && !useClassificationCodes
    },
    canEdit() {
      const isBinding = this.biddingTypeIds?.length
      || this.classificationCodes?.length

      return !isBinding
    },
    biddingTypeIds() {
      return this.item?.bindingCondition ? this.item.bindingCondition?.biddingTypeIds?.filter(i => i) || [] : []
    },
    classificationCodes() {
      return this.item?.bindingCondition ? this.item.bindingCondition?.classificationCodes?.filter(i => i) || [] : []
    },
  },
  methods: {
    createIcon() {
      if (this.item?.type?.icon) {
        this.icon = this.item?.type?.icon
      } else {
        this.icon = this.$_getIconByType(this.item)
      }
    }
  },
  watch: {
    'item.typeId'() {
      this.createIcon()
    }
  },
  mounted() {
    this.createIcon()
  },
  components: {
    AdditionalBlockActions
  }
}
</script>
<style lang="scss" scoped>
.additional-field-row {
  min-height: 40px;
  &__title {
    max-width: calc(100% - 32px);

  }
  &__title-wrapper {
    overflow: hidden;
    white-space: normal;
    max-width: calc(100% - 125px);
    white-space: pre-wrap;
  }
  &__btn {
    width: 122px;
  }
  &::marker {
    content: '';
  }
}
</style>
